const ComponentBase = require('../../base/ComponentBase');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 移动的地图覆盖物
 * @augments G.base.ComponentBase
 * @alias G.interact.MousemoveOverlay
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {String} options.content 覆盖物内容,
 * @param {String} options.cursor 鼠标样式,
 * @param {Boolean} [options.clearlast] 是否清除上次覆盖物
 * @param {Function} [options.callback] 点击后的回调方法
 * @param {int[]} [options.offset] 偏移量，以像素为单位
 * @param {String} [options.lnglatFormat] 坐标格式，默认为"DD"；"DD":经纬度坐标小数值,"DMS"：经纬度坐标度分秒,"MM":原始坐标值
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        var defaultContent = '<span>自定义内容</span>';
        let content = options.content || defaultContent;
        this.options.element = this.parseDom(content);
        this.options.cursor = options.cursor || 'crosshair';
        this.options.clearlast = options.clearlast === undefined ? true : options.clearlast;
        this.options.callback = options.callback;
        this.options.position = new g2.sfs.Point({spatialReference: this.map.getSrid()});
        this.options.offset = options.offset || [2, 2];
        this.options.keep = options.keep || false;
        this.overlayWare = new g2.widget.OverlayWare({
            map: this.map
        });
        this.overlay = null;
    },
    parseDom(elementStr){
        var div = document.createElement("div");
        div.innerHTML = elementStr;
        return div.childNodes[0];
    },
    /**
     * @inheritDoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
        this.overlay = null;
        this.map.listen('mousemove', this._mousemove, this);
        this.map.listen('mousedown', this._mousedown, this);
        this.map.setCursor(this.options.cursor);
    },
    /**
     * @inheritDoc
     */
    unload: function () {
        this.overlay = null;
        this.overlayWare.clear();
        this.map.setCursor('default');
        this.map.off('mousemove', this._mousemove, this);
        this.map.off('mousedown', this._mousedown, this);
        ComponentBase.prototype.unload.call(this);
    },
    /**
     * @inheritDoc
     */
    destroy() {
        this.unload();
        this.overlayWare = null;
        ComponentBase.prototype.destroy.call(this);
    },
    
    _mousemove: function (evt) {
        if (!this.overlay){
            this.overlay = new g2.widget.OverLay({
                position: this.options.position,
                element: this.options.element,
                id: 'mousemoveoverlay',
                stopEvent: false,
                offset: this.options.offset || [2, 2]
            });
            this.overlayWare.add(this.overlay);
        }
        this.overlay.position.x = evt.mapX;
        this.overlay.position.y = evt.mapY;
        this.overlayWare.update(this.overlay);
    },
    
    _mousedown: function (evt) {
        if (this.options.keep){
            if (evt.button === 0) {
                this.overlay.position.x = evt.mapX;
                this.overlay.position.y = evt.mapY;
                this.overlayWare.update(this.overlay);
                this.map.off('mousemove', this._mousemove, this);
                this.map.off('mousedown', this._mousedown, this);
                this.map.setCursor('default');
                if (typeof this.options.callback === "function") {
                    this.options.callback.call(this, evt);
                }
            }
        }else{
            this.unload();
            // this.map.setCursor('default');
            // this.overlay = null;
            // this.overlayWare.remove('mousemoveoverlay');
            // this.map.off('mousemove', this._mousemove, this);
            // this.map.off('mousedown', this._mousedown, this);
        }
       /* else if (evt.button === 2) {
            this.map.setCursor('default');
            this.overlay = null;
            this.overlayWare.remove('mousemoveoverlay');
            this.map.off('mousemove', this._mousemove, this);
            this.map.off('mousedown', this._mousedown, this);
        }*/
    },
    
    
});
module.exports = component;
